import { render, staticRenderFns } from "./SubdomainSettings.vue?vue&type=template&id=1d8ef814&scoped=true&"
import script from "./SubdomainSettings.vue?vue&type=script&lang=js&"
export * from "./SubdomainSettings.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainSettings.vue?vue&type=style&index=0&id=1d8ef814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ef814",
  null
  
)

export default component.exports